let model = {};

// dữ liệu form
model.dataForm = {
    "employee_id": undefined, // required Mã nhân viên
    "company_id": undefined, // required Mã công ty
    "company_name": undefined, // optional Tên công ty
    "salary_period_id": undefined, // required Kỳ lương Id
    "salary_period_name": undefined, // required Tên kỳ lương
    "shift_id": undefined, // required Ca
    "shift_name": undefined, // optional Tên ca
    "date": undefined, // required Ngày công trong tháng
    "work_value": undefined, // required Số công
    "checkin_time": // optional Giờ vào
    {
        "hour": undefined, // optional Giờ
        "minute": undefined, // optional Phút
    },
    "checkout_time": // optional Giờ ra
    {
        "hour": undefined, // optional Giờ
        "minute": undefined, // optional Phút
    },
    "minute_go_early": undefined, // optional Số phút đi sớm
    "minute_go_late": undefined, // optional Số phút đi muộn
    "minute_overtime": undefined, // optional Số phút làm thêm giờ
    "employee_request_ids": [], // optional Mã yêu cầu của nhân viên
    "sealed": undefined, // required Đã chốt chưa
    "sealed_user_id": undefined, // optional Người chốt
    "sealed_at": undefined, // optional Thời điểm chốt
    "created_at": undefined, // required Thời điểm tạo
    "updated_at": undefined, // required Thời điểm cập nhật
    "disabled": undefined, // required Đã bị khóa chưa
};

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataCreateNewWork = {
  employee_id: undefined,
  company_id: undefined,
  salary_period_id: undefined,
  salary_period_name: undefined,
  shift_id: undefined,
  date: 0,
  work_value: 0,
  minute_go_home_early: 0,
  minute_go_late: 0,
  minute_overtime: 0,
  minute_go_early: 0,
  number_of_go_out: 0,
  number_of_day: 0,
  sealed: true
};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    filtersWork: "",
    recordSelected: [],
    dataSearchSalaryPeriod: {
        value: {
            "salary_period_id":""
        },
        valid: {
            "salary_period_id":[]
        },
        operator: {
            "salary_period_id":"",
        }
    },
    dataSearch: {
        value: {
            "condition":""
        },
        valid: {
            "condition": []
        },
        operator: {
            "condition": "$vn_text=", //:regex:, $vn_text=Viêt nam
        }
    }
};

export default model;
